import { Ref, useEffect, useImperativeHandle, useState } from "react";
import { Polygon } from "../elements/Polygon";
import MapPropertiesService from '../../services/MapPropertiesService';

interface PcsFeaturePolygonRef {
    onSelect: (ids: number[]) => void
}
interface PcsFeaturePolygonProps {
    ref: Ref<PcsFeaturePolygonRef>,
    source: any,
    disabled?: boolean,
    onClick?: (feature: any, latLng: any) => void,
}
export const PcsFeaturePolygon = ({
    ref,
    source,
    disabled,
    onClick
}: PcsFeaturePolygonProps) => {

    useImperativeHandle(ref, () => ({
        onSelect(ids: number[]) {
            if (!ids.includes(source.id)) return;
            onToggleIsSelect(true);
        }
    }));

    const mapProperties = MapPropertiesService.properties;

    const [fillColor, setFillColor] = useState(mapProperties.ColorAvailable);
    const [strokeWeight, setStrokeWeight] = useState(1);

    useEffect(() => {
        if (!source.properties.isSelected) return;
        setFillColor(mapProperties.ColorSelected);
    }, []);

    return (
        <Polygon
            paths={source.paths}
            fillColor={fillColor}
            strokeWeight={strokeWeight}
            strokeColor={mapProperties.ColorBorder}
            onClick={handleOnClick}
            onMouseOver={onMouseOver}
            onMouseOut={onMouseOut}
        />
    );

    function onMouseOver() {
        setStrokeWeight(4);
    }

    function onMouseOut() {
        setStrokeWeight(2);
    }

    function handleOnClick(e: any) {
        if (!disabled) {
            onToggleIsSelect(!source.properties.isSelected);
        }

        if (!onClick) return;

        onClick(source, e.latLng);
    }

    function onToggleIsSelect(isSelected:boolean) {
        source.properties.isSelected = isSelected;
        setFillColor(isSelected ? mapProperties.ColorSelected : mapProperties.ColorAvailable);
    }
}
